import { api } from './api';

export const fetchTelemetry = (id, params) => {
  return api.get(`/telemetry/${id}`, params);
};

export const fetchUpdateTelemetry = (id, payload) => {
  return api.put(`/telemetry/${id}`, payload);
};
